import { SIGNIN, SIGNOUT_SUCCESS } from "../constant";

export const signIn = (user) => {
	return {
		type: SIGNIN,
		payload: user,
	};
};

export const signOut = () => {
	localStorage.clear();
	return {
		type: SIGNOUT_SUCCESS,
	};
};
